import { Typography, InputLabel, Container, Stack, Grid, Box, FormControl, TextField, InputAdornment, Divider, Button } from "@mui/material";
import { useState } from "react";
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import { DemoItem } from '@mui/x-date-pickers/internals/demo';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import Downloadpdficon from './Downloadpdficon.png'
import pdficon from './pdf_9496432.png'
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { PDFDocument } from 'pdf-lib';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useParams } from 'react-router-dom';
import classes from "./ParticipanteClasess.css";
import CheckCircle from '@mui/icons-material/CheckCircle';
import Cancel from '@mui/icons-material/Cancel';
import * as React from 'react';
import logoblack from '../../components/logoinjupemp.png'
import dayjs from 'dayjs';
import 'dayjs/locale/es'; // Importa el archivo de localización para español
import CircularProgress from '@mui/material/CircularProgress';
import DialogContent from '@mui/material/DialogContent';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import DialogContentText from '@mui/material/DialogContentText';
import { Dialog, DialogTitle, DialogActions, Backdrop } from "@mui/material";
import AvalPrecargado from "./Components/aval1_precargado";
import Aval2Precargado from "./Components/aval2_precargado";
import { useContext } from "react";
import { ContextSession } from "../../services/ContextSession";
import { post } from "../../services/http";
import { CalendarIcon } from '@mui/x-date-pickers/icons';
dayjs.locale('es'); // Establece el idioma local a español

async function getSolicitudInfo(accesos, ip, sid) {
    let json = { SolicitudID: sid };
    let url = ip + "/api/completa/";
    let auto = "Bearer " + accesos;

    let datas = await post(url, json, auto);
    return datas;
};

async function sendDataSolicitud(accesos, ip, json) {
    try {
        const data = new FormData();

        //data.append('data', JSON.stringify(json));
      //  console.log(data);

        let url = ip + "/api/estado/";
        let auto = "Bearer " + accesos;

        let datas = await post(url, json);
        return datas;
    } catch (error) {
        console.error(error);
    }
}

function SolicitudCarga() {

    let sessi = useContext(ContextSession);
    //const { SolicitudID } = useParams(); // Aquí obtenemos el SolicitudID desde la URL
    //const [tipoPrestamo, setTipoPrestamo] = useState('all');
    const [selectedDate, setSelectedDate] = React.useState(null);
    const [fechaVacia, setFechaVacia] = React.useState(null);
    const [selectedDateAval2, setSelectedDateAval2] = React.useState(null);
    const [fechaVaciaAval2, setFechaVaciaAval2] = React.useState(null);
    const [filas, setFilas] = useState([]);
    const [loading, setLoading] = useState(true);
    const [openDialogEnviada, setOpenDialogEnviada] = useState(false);
    const [openDialogRechazada, setOpenDialogRechazada] = useState(false);
    const [pdfFile, setPdfFile] = useState(null);

    //Archivo PDF
    const [pdfUrl, setPdfUrl] = React.useState('');
    const [pdfUrlAval1, setPdfUrlAval1] = React.useState('');
    const [pdfUrlAval2, setPdfUrlAval2] = React.useState('');
    const [pdfUrlVoucher, setPdfUrlVoucher] = React.useState('');
    const [openPdf, setOpenPdf] = useState(false);
    const [openPdfAval1, setOpenPdfAval1] = useState(false);
    const [openPdfAval2, setOpenPdfAval2] = useState(false);
    const [openPdfVoucher, setOpenPdfVoucher] = useState(false);

    const handleCloseDialogEnviada = () => {
        setOpenDialogEnviada(false);
    };

    const handleCloseDialogRechazada = () => {
        setOpenDialogRechazada(false);
    };

    //Variables de estado para el formulario

    //Datos de la solicitud
    const [faseSolicitud, setFaseSolicitud] = useState("");
    const [estadoSolicitud, setEstadoSolicitud] = useState(null);
    const [observacion, setObservacion] = useState("");
    const [idEnviar, setIDenviar] = useState("");

    //Datos del solicitante
    const [numeroSolicitud, setNumeroSolicitud] = useState("");
    const [numeroCotizante, setNumeroCotizante] = useState("");
    const [tipoPrestamo, setTipoPrestamo] = useState("");
    const [montoSolicitado, setMontoSolicitado] = useState("");
    const [identidadSolicitante, setIdentidadSolicitante] = useState("");
    const [nombresSolicitante, setNombresSolicitante] = useState("");
    const [apellidosSolicitante, setApellidosSolicitante] = useState("");
    const [nacimientoSolicitante, setNacimientoSolicitante] = useState("");
    const [profesionSolicitante, setProfesionSolicitante] = useState("");
    const [tipoViviendaSolicitante, setTipoViviendaSolicitante] = useState("");
    const [direccionSolicitante, setDireccionSolicitante] = useState("");
    const [barrioSolicitante, setBarrioSolicitante] = useState("");
    const [avenidaSolicitante, setAvenidaSolicitante] = useState("");
    const [calleSolicitante, setCalleSolicitante] = useState("");
    const [casaSolicitante, setCasaSolicitante] = useState("");
    const [ciudadSolicitante, setCiudadSolicitante] = useState("");
    const [departamentoSolicitante, setDepartamentoSolicitante] = useState("");
    const [estadoCivilSolicitante, setEstadoCivilSolicitante] = useState("");
    const [referenciaDomicilioSolicitante, setReferenciaDomicilioSolicitante] = useState("");
    const [fijoSolicitante, setFijoSolicitante] = useState("");
    const [movilSolicitante, setMovilSolicitante] = useState("");
    const [correoSolicitante, setCorreoSolicitante] = useState("");

    //Informacion laboral del solicitante
    //const [Solicitante, setSolicitante] = useState("");
    const [dependenciaSolicitante, setDependenciaSolicitante] = useState("");
    const [ramoSolicitante, setRamoSolicitante] = useState("");
    const [telefonoLaboralSolicitante, setTelefonoLaboralSolicitante] = useState("");
    const [barrioLaboralSolicitante, setBarrioLaboralSolicitante] = useState("");
    const [avenidaLaboralSolicitante, setAvenidaLaboralSolicitante] = useState("");
    const [calleLaboralSolicitante, setCalleLaboralSolicitante] = useState("");
    const [casaLaboralSolicitante, setCasaLaboralSolicitante] = useState("");
    const [ciudadLaboralSolicitante, setCiudadLaboralSolicitante] = useState("");
    const [departamentoLaboralSolicitante, setDepartamentoLaboralSolicitante] = useState("");
    const [sueldoMensualSolicitante, setSueldoMensualSolicitante] = useState("");
    const [otrosIngresosSolicitante, setOtrosIngresosSolicitante] = useState("");
    const [sueldoNetoSolicitante, setSueldoNetoSolicitante] = useState("");
    const [puestoSolicitante, setPuestoSolicitante] = useState("");
    const [tiempoLaborarASolicitante, setTiempoLaborarASolicitante] = useState("");
    const [tiempoLaborarMSolicitante, setTiempoLaborarMSolicitante] = useState("");

    //Referencias Personales
    const [referencia1, setReferencia1] = useState("");
    const [parentescoReferencia1, setParentescoReferencia1] = useState("");
    const [direccionReferencia1, setDireccionReferencia1] = useState("");
    const [telefonoReferencia1, setTelefonoReferencia1] = useState("");
    const [referencia2, setReferencia2] = useState("");
    const [parentescoReferencia2, setParentescoReferencia2] = useState("");
    const [direccionReferencia2, setDireccionReferencia2] = useState("");
    const [telefonoReferencia2, setTelefonoReferencia2] = useState("");
    const [idReferencia1, setIdReferencia1] = useState("");
    const [idReferencia2, setIdReferencia2] = useState("");

    //Aval1
    const [idAval1, setIdAval1] = useState("");
    const [identidadAval1, setIdentidadAval1] = useState("");
    const [nombresAval1, setNombresAval1] = useState("");
    const [apellidosAval1, setApellidosAval1] = useState("");
    const [nacimientoAval1, setNacimientoAval1] = useState("");
    const [profesionAval1, setProfesionAval1] = useState("");
    const [tipoViviendaAval1, setTipoViviendaAval1] = useState("");
    const [direccionAval1, setDireccionAval1] = useState("");
    const [barrioAval1, setBarrioAval1] = useState("");
    const [avenidaAval1, setAvenidaAval1] = useState("");
    const [calleAval1, setCalleAval1] = useState("");
    const [casaAval1, setCasaAval1] = useState("");
    const [ciudadAval1, setCiudadAval1] = useState("");
    const [departamentoAval1, setDepartamentoAval1] = useState("");
    const [estadoCivilAval1, setEstadoCivilAval1] = useState("");
    const [referenciaDomicilioAval1, setReferenciaDomicilioAval1] = useState("");
    const [fijoAval1, setFijoAval1] = useState("");
    const [movilAval1, setMovilAval1] = useState("");
    const [correoAval1, setCorreoAval1] = useState("");
    const [dependenciaAval1, setDependenciaAval1] = useState("");
    const [ramoAval1, setRamoAval1] = useState("");
    const [telefonoLaboralAval1, setTelefonoLaboralAval1] = useState("");
    const [barrioLaboralAval1, setBarrioLaboralAval1] = useState("");
    const [avenidaLaboralAval1, setAvenidaLaboralAval1] = useState("");
    const [calleLaboralAval1, setCalleLaboralAval1] = useState("");
    const [casaLaboralAval1, setCasaLaboralAval1] = useState("");
    const [ciudadLaboralAval1, setCiudadLaboralAval1] = useState("");
    const [departamentoLaboralAval1, setDepartamentoLaboralAval1] = useState("");
    const [sueldoMensualAval1, setSueldoMensualAval1] = useState("");
    const [otrosIngresosAval1, setOtrosIngresosAval1] = useState("");
    const [sueldoNetoAval1, setSueldoNetoAval1] = useState("");
    const [puestoAval1, setPuestoAval1] = useState("");
    const [tiempoLaborarAAval1, setTiempoLaborarAAval1] = useState("");
    const [tiempoLaborarMAval1, setTiempoLaborarMAval1] = useState("");

    //Aval 2
    const [idAval2, setIdAval2] = useState("");
    const [identidadAval2, setIdentidadAval2] = useState("");
    const [nombresAval2, setNombresAval2] = useState("");
    const [apellidosAval2, setApellidosAval2] = useState("");
    const [nacimientoAval2, setNacimientoAval2] = useState("");
    const [profesionAval2, setProfesionAval2] = useState("");
    const [tipoViviendaAval2, setTipoViviendaAval2] = useState("");
    const [direccionAval2, setDireccionAval2] = useState("");
    const [barrioAval2, setBarrioAval2] = useState("");
    const [avenidaAval2, setAvenidaAval2] = useState("");
    const [calleAval2, setCalleAval2] = useState("");
    const [casaAval2, setCasaAval2] = useState("");
    const [ciudadAval2, setCiudadAval2] = useState("");
    const [departamentoAval2, setDepartamentoAval2] = useState("");
    const [estadoCivilAval2, setEstadoCivilAval2] = useState("");
    const [referenciaDomicilioAval2, setReferenciaDomicilioAval2] = useState("");
    const [fijoAval2, setFijoAval2] = useState("");
    const [movilAval2, setMovilAval2] = useState("");
    const [correoAval2, setCorreoAval2] = useState("");
    const [dependenciaAval2, setDependenciaAval2] = useState("");
    const [ramoAval2, setRamoAval2] = useState("");
    const [telefonoLaboralAval2, setTelefonoLaboralAval2] = useState("");
    const [barrioLaboralAval2, setBarrioLaboralAval2] = useState("");
    const [avenidaLaboralAval2, setAvenidaLaboralAval2] = useState("");
    const [calleLaboralAval2, setCalleLaboralAval2] = useState("");
    const [casaLaboralAval2, setCasaLaboralAval2] = useState("");
    const [ciudadLaboralAval2, setCiudadLaboralAval2] = useState("");
    const [departamentoLaboralAval2, setDepartamentoLaboralAval2] = useState("");
    const [sueldoMensualAval2, setSueldoMensualAval2] = useState("");
    const [otrosIngresosAval2, setOtrosIngresosAval2] = useState("");
    const [sueldoNetoAval2, setSueldoNetoAval2] = useState("");
    const [puestoAval2, setPuestoAval2] = useState("");
    const [tiempoLaborarAAval2, setTiempoLaborarAAval2] = useState("");
    const [tiempoLaborarMAval2, setTiempoLaborarMAval2] = useState("");

    //TRANSFERENCIA DE PAGO DEL MONTO APROBADO A CUENTA BANCARIA
    const [tipoCuenta, setTipoCuenta] = useState("");
    const [nombreBanco, setNombreBanco] = useState("");
    const [noCuenta, setNoCuenta] = useState("");

    //Deudas A Consolidar
    //fila 1
    const [idFila1, setIdFila1] = useState("");
    const [institucionNombre1, setInstitucionNombre1] = useState("");
    const [montoLempiras1, setMontoLempiras1] = useState("");
    const [montoDolares1, setMontoDolares1] = useState("");
    const [totalLempiras1, setTotalLempiras1] = useState("");
    const [consolidacionTotal1, setConsolidacionTotal1] = useState("");
    const [consolidacionParcial1, setConsolidacionParcial1] = useState("");

    //fila 2
    const [idFila2, setIdFila2] = useState("");
    const [institucionNombre2, setInstitucionNombre2] = useState("");
    const [montoLempiras2, setMontoLempiras2] = useState("");
    const [montoDolares2, setMontoDolares2] = useState("");
    const [totalLempiras2, setTotalLempiras2] = useState("");
    const [consolidacionTotal2, setConsolidacionTotal2] = useState("");
    const [consolidacionParcial2, setConsolidacionParcial2] = useState("");

    //fila 3
    const [idFila3, setIdFila3] = useState("");
    const [institucionNombre3, setInstitucionNombre3] = useState("");
    const [montoLempiras3, setMontoLempiras3] = useState("");
    const [montoDolares3, setMontoDolares3] = useState("");
    const [totalLempiras3, setTotalLempiras3] = useState("");
    const [consolidacionTotal3, setConsolidacionTotal3] = useState("");
    const [consolidacionParcial3, setConsolidacionParcial3] = useState("");

    //fila 4
    const [idFila4, setIdFila4] = useState("");
    const [institucionNombre4, setInstitucionNombre4] = useState("");
    const [montoLempiras4, setMontoLempiras4] = useState("");
    const [montoDolares4, setMontoDolares4] = useState("");
    const [totalLempiras4, setTotalLempiras4] = useState("");
    const [consolidacionTotal4, setConsolidacionTotal4] = useState("");
    const [consolidacionParcial4, setConsolidacionParcial4] = useState("");

    //fila 5
    const [idFila5, setIdFila5] = useState("");
    const [institucionNombre5, setInstitucionNombre5] = useState("");
    const [montoLempiras5, setMontoLempiras5] = useState("");
    const [montoDolares5, setMontoDolares5] = useState("");
    const [totalLempiras5, setTotalLempiras5] = useState("");
    const [consolidacionTotal5, setConsolidacionTotal5] = useState("");
    const [consolidacionParcial5, setConsolidacionParcial5] = useState("");

    //fila 6
    const [idFila6, setIdFila6] = useState("");
    const [totalMontoLempiras1, setTotalMontoLempiras1] = useState("");
    const [totalMontoDolares1, setTotalMontoDolares1] = useState("");
    const [totalTotalLempiras1, setTotalTotalLempiras1] = useState("");
    const [totalConsolidacionTotal1, setTotalConsolidacionTotal1] = useState("");
    const [totalConsolidacionParcial1, setTotalConsolidacionParcial1] = useState("");

    //fila 7
    const [idFila7, setIdFila7] = useState("");
    const [totalMontoLempiras2, setTotalMontoLempiras2] = useState("");
    const [totalMontoDolares2, setTotalMontoDolares2] = useState("");
    const [totalTotalLempiras2, setTotalTotalLempiras2] = useState("");
    const [totalConsolidacionTotal2, setTotalConsolidacionTotal2] = useState("");
    const [totalConsolidacionParcial2, setTotalConsolidacionParcial2] = useState("");

    const aprobarSolicitud = () => {
        const jsonOutput = {
            "SolicitudID": idEnviar,//numeroSolicitud,
            "observacion": document.getElementById("notaAprobacion").value,
            "aprobado": true,
        }

        let token = sessi.sessionData.token;

        sendDataSolicitud(token, sessi.ip, jsonOutput);
        setOpenDialogEnviada(true);
        handleClose();
    }

    const rechazarSolicitud = () => {
        const jsonOutput = {
            "SolicitudID": idEnviar,//numeroSolicitud,
            "observacion": document.getElementById("notaRechazo").value,
            "aprobado": false,
        }

        let token = sessi.sessionData.token;

        sendDataSolicitud(token, sessi.ip, jsonOutput);
        setOpenDialogRechazada(true);
        handleCloseRechazar();
    }

    const handleButtonIdentidad = async () => {
        if (filas && filas.imagenes && filas.imagenes.SolDNI) {
            const base64Images = filas.imagenes.SolDNI;
            const pdfDoc = await PDFDocument.create();

            for (const base64Image of base64Images) {
                const imageBytes = Uint8Array.from(atob(base64Image), c => c.charCodeAt(0));
                const image = await pdfDoc.embedPng(imageBytes);
                const page = pdfDoc.addPage([image.width, image.height]);
                page.drawImage(image, {
                    x: 0,
                    y: 0,
                    width: image.width,
                    height: image.height
                });
            }

            const pdfBytes = await pdfDoc.save();
            const pdfBlob = new Blob([pdfBytes], { type: 'application/pdf' });
            const pdfUrl = URL.createObjectURL(pdfBlob);
            setPdfUrl(pdfUrl);
            setOpenPdf(true);
        }
    };

    const handleCloseIdentidad = () => {
        setOpenPdf(false);
        URL.revokeObjectURL(pdfUrl);
        setPdfUrl('');
    };

    const handleButtonAval1 = async () => {
        if (filas && filas.imagenes && filas.imagenes.Aval1DNI) {
            const base64Images = filas.imagenes.Aval1DNI;
            const pdfDoc = await PDFDocument.create();

            for (const base64Image of base64Images) {
                const imageBytes = Uint8Array.from(atob(base64Image), c => c.charCodeAt(0));
                const image = await pdfDoc.embedPng(imageBytes);
                const page = pdfDoc.addPage([image.width, image.height]);
                page.drawImage(image, {
                    x: 0,
                    y: 0,
                    width: image.width,
                    height: image.height
                });
            }

            const pdfBytes = await pdfDoc.save();
            const pdfBlob = new Blob([pdfBytes], { type: 'application/pdf' });
            const pdfUrl = URL.createObjectURL(pdfBlob);
            setPdfUrlAval1(pdfUrl);
            setOpenPdfAval1(true);
        }
    };

    const handleCloseAval1 = () => {
        setOpenPdfAval1(false);
        URL.revokeObjectURL(pdfUrlAval1);
        setPdfUrlAval1('');
    };

    const handleButtonAval2 = async () => {
        if (filas && filas.imagenes && filas.imagenes.Aval2DNI) {
            const base64Images = filas.imagenes.Aval2DNI;
            const pdfDoc = await PDFDocument.create();

            for (const base64Image of base64Images) {
                const imageBytes = Uint8Array.from(atob(base64Image), c => c.charCodeAt(0));
                const image = await pdfDoc.embedPng(imageBytes);
                const page = pdfDoc.addPage([image.width, image.height]);
                page.drawImage(image, {
                    x: 0,
                    y: 0,
                    width: image.width,
                    height: image.height
                });
            }

            const pdfBytes = await pdfDoc.save();
            const pdfBlob = new Blob([pdfBytes], { type: 'application/pdf' });
            const pdfUrl = URL.createObjectURL(pdfBlob);
            setPdfUrlAval2(pdfUrl);
            setOpenPdfAval2(true);
        }
    };

    const handleCloseAval2 = () => {
        setOpenPdfAval2(false);
        URL.revokeObjectURL(pdfUrlAval2);
        setPdfUrlAval2('');
    };

    const handleButtonVoucher = async () => {
        if (filas && filas.imagenes && filas.imagenes.Voucher) {
            const base64Images = filas.imagenes.Voucher;
            const pdfDoc = await PDFDocument.create();

            for (const base64Image of base64Images) {
                const imageBytes = Uint8Array.from(atob(base64Image), c => c.charCodeAt(0));
                const image = await pdfDoc.embedPng(imageBytes);
                const page = pdfDoc.addPage([image.width, image.height]);
                page.drawImage(image, {
                    x: 0,
                    y: 0,
                    width: image.width,
                    height: image.height
                });
            }

            const pdfBytes = await pdfDoc.save();
            const pdfBlob = new Blob([pdfBytes], { type: 'application/pdf' });
            const pdfUrl = URL.createObjectURL(pdfBlob);
            setPdfUrlVoucher(pdfUrl);
            setOpenPdfVoucher(true);
        }
    };

    const handleCloseVoucher = () => {
        setOpenPdfVoucher(false);
        URL.revokeObjectURL(pdfUrlVoucher);
        setPdfUrlVoucher('');
    };

    React.useEffect(() => {
        const container = document.getElementById('my-container');
        container.style.zoom = "80%";

        async function fetchData() {
            let token = sessi.sessionData.token;
            let sid = sessi.getVariable("SolicitudPrestamo");
            const data = await getSolicitudInfo(token, sessi.ip, sid);
          //  console.log(`El SolicitudID Es: ${sid}`);
            setFilas(data);
            setLoading(false);
         //   console.log("FILAS ", data);

            //Asignar valores a los TextField

            //Datos Del  
            const response = await getSolicitudInfo(sessi.sessionData.token, sessi.ip, sessi.getVariable("SolicitudPrestamo"));
         //   console.log("resultado de la SOLICITUD es: !!", response.Solicitud, response);
            if (response.Solicitud && response.Solicitud[0]) {

                response.Solicitud[0].NumeroSolicitud !== undefined && setNumeroSolicitud(response.Solicitud[0].NumeroSolicitud);
                response.Solicitud[0].NumeroCotizante !== undefined && setNumeroCotizante(response.Solicitud[0].NumeroCotizante);
                response.Solicitud[0].TipoPrestamo !== undefined && setTipoPrestamo(response.Solicitud[0].TipoPrestamo);
                response.Solicitud[0].MontoSolicitado !== undefined && setMontoSolicitado(response.Solicitud[0].MontoSolicitado);
            }

            if (response.DatosSolicitante && response.DatosSolicitante[0]) {
                response.DatosSolicitante[0].NumeroIdentidad !== undefined && setIdentidadSolicitante(response.DatosSolicitante[0].NumeroIdentidad);
                response.DatosSolicitante[0].Nombres !== undefined && setNombresSolicitante(response.DatosSolicitante[0].Nombres);
                response.DatosSolicitante[0].Apellidos !== undefined && setApellidosSolicitante(response.DatosSolicitante[0].Apellidos);
                response.DatosSolicitante[0].FechaNacimiento !== undefined && setNacimientoSolicitante(response.DatosSolicitante[0].FechaNacimiento);
                response.DatosSolicitante[0].Profesion !== undefined && setProfesionSolicitante(response.DatosSolicitante[0].Profesion);
                response.DatosSolicitante[0].TipoVivienda !== undefined && setTipoViviendaSolicitante(response.DatosSolicitante[0].TipoVivienda);
                response.DatosSolicitante[0].BarrioCol !== undefined && setBarrioSolicitante(response.DatosSolicitante[0].BarrioCol);
                response.DatosSolicitante[0].Ave !== undefined && setAvenidaSolicitante(response.DatosSolicitante[0].Ave);
                response.DatosSolicitante[0].Calle !== undefined && setCalleSolicitante(response.DatosSolicitante[0].Calle);
                response.DatosSolicitante[0].CasaNo !== undefined && setCasaSolicitante(response.DatosSolicitante[0].CasaNo);
                response.DatosSolicitante[0].Ciudad !== undefined && setCiudadSolicitante(response.DatosSolicitante[0].Ciudad);
                response.DatosSolicitante[0].Departamento !== undefined && setDepartamentoSolicitante(response.DatosSolicitante[0].Departamento);
                response.DatosSolicitante[0].EstadoCivil !== undefined && setEstadoCivilSolicitante(response.DatosSolicitante[0].EstadoCivil);
                response.DatosSolicitante[0].ReferenciaDomicilio !== undefined && setReferenciaDomicilioSolicitante(response.DatosSolicitante[0].ReferenciaDomicilio);
                response.DatosSolicitante[0].TelefonoFijo !== undefined && setFijoSolicitante(response.DatosSolicitante[0].TelefonoFijo);
                response.DatosSolicitante[0].TelefonoMovil !== undefined && setMovilSolicitante(response.DatosSolicitante[0].TelefonoMovil);
                response.DatosSolicitante[0].CorreoElectronico !== undefined && setCorreoSolicitante(response.DatosSolicitante[0].CorreoElectronico);
            }

            //datos de la solicitud
            if (response.Solicitud && response.Solicitud[0]) {
                setEstadoSolicitud(response.Solicitud[0].aprobado);
                setFaseSolicitud(response.Solicitud[0].Estado ?? '');
                setObservacion(response.Solicitud[0].observacion ?? '');
                setIDenviar(response.Solicitud[0].SolicitudID ?? '');
            }

            //Informacion laboral del solicitante
            if (response.InformacionLaboral && response.InformacionLaboral[0]) {
                //setSolicitante(response.InformacionLaboral[0].);
                response.InformacionLaboral[0].DependenciaTrabajo !== undefined && setDependenciaSolicitante(response.InformacionLaboral[0].DependenciaTrabajo);
                response.InformacionLaboral[0].Ramo !== undefined && setRamoSolicitante(response.InformacionLaboral[0].Ramo);
                response.InformacionLaboral[0].Telefono !== undefined && setTelefonoLaboralSolicitante(response.InformacionLaboral[0].Telefono);
                response.InformacionLaboral[0].BarrioCol !== undefined && setBarrioLaboralSolicitante(response.InformacionLaboral[0].BarrioCol);
                response.InformacionLaboral[0].Ave !== undefined && setAvenidaLaboralSolicitante(response.InformacionLaboral[0].Ave);
                response.InformacionLaboral[0].Calle !== undefined && setCalleLaboralSolicitante(response.InformacionLaboral[0].Calle);
                response.InformacionLaboral[0].CasaNo !== undefined && setCasaLaboralSolicitante(response.InformacionLaboral[0].CasaNo);
                response.InformacionLaboral[0].Ciudad !== undefined && setCiudadLaboralSolicitante(response.InformacionLaboral[0].Ciudad);
                response.InformacionLaboral[0].Departamento !== undefined && setDepartamentoLaboralSolicitante(response.InformacionLaboral[0].Departamento);
                response.InformacionLaboral[0].SueldoMensual !== undefined && setSueldoMensualSolicitante(response.InformacionLaboral[0].SueldoMensual);
                response.InformacionLaboral[0].OtrosIngresos !== undefined && setOtrosIngresosSolicitante(response.InformacionLaboral[0].OtrosIngresos);
                response.InformacionLaboral[0].SueldoNeto !== undefined && setSueldoNetoSolicitante(response.InformacionLaboral[0].SueldoNeto);
                response.InformacionLaboral[0].Puesto !== undefined && setPuestoSolicitante(response.InformacionLaboral[0].Puesto);
                response.InformacionLaboral[0].TiempoLaborarAnios !== undefined && setTiempoLaborarASolicitante(response.InformacionLaboral[0].TiempoLaborarAnios);
                response.InformacionLaboral[0].TiempoLaborarMeses !== undefined && setTiempoLaborarMSolicitante(response.InformacionLaboral[0].TiempoLaborarMeses);
            }

            //Referencias Personales
            if (response.ReferenciasPersonales[0]) {
                response.ReferenciasPersonales[0].ReferenciaID !== undefined && setIdReferencia1(response.ReferenciasPersonales[0].ReferenciaID);
                response.ReferenciasPersonales[0].Nombre !== undefined && setReferencia1(response.ReferenciasPersonales[0].Nombre);
                response.ReferenciasPersonales[0].Parentesco !== undefined && setParentescoReferencia1(response.ReferenciasPersonales[0].Parentesco);
                response.ReferenciasPersonales[0].Direccion !== undefined && setDireccionReferencia1(response.ReferenciasPersonales[0].Direccion);
                response.ReferenciasPersonales[0].Telefono !== undefined && setTelefonoReferencia1(response.ReferenciasPersonales[0].Telefono);
            }
            if (response.ReferenciasPersonales[1]) {
                response.ReferenciasPersonales[1].ReferenciaID !== undefined && setIdReferencia2(response.ReferenciasPersonales[1].ReferenciaID);
                response.ReferenciasPersonales[1].Nombre !== undefined && setReferencia2(response.ReferenciasPersonales[1].Nombre);
                response.ReferenciasPersonales[1].Parentesco !== undefined && setParentescoReferencia2(response.ReferenciasPersonales[1].Parentesco);
                response.ReferenciasPersonales[1].Direccion !== undefined && setDireccionReferencia2(response.ReferenciasPersonales[1].Direccion);
                response.ReferenciasPersonales[1].Telefono !== undefined && setTelefonoReferencia2(response.ReferenciasPersonales[1].Telefono);
            }

            if (response.Solicitud[0].TipoPrestamo === "Con Aval" || response.Solicitud[0].TipoPrestamo === "Consolidacion de Deuda") {

                //Aval1
                setIdAval1(response.DatosAval[0].AvalID ?? '');
                setIdentidadAval1(response.DatosAval[0].NumeroIdentidad);
                setNombresAval1(response.DatosAval[0].Nombres);
                setApellidosAval1(response.DatosAval[0].Apellidos);
                setNacimientoAval1(response.DatosAval[0].FechaNacimiento ?? '');
                setProfesionAval1(response.DatosAval[0].Profesion ?? '');
                setTipoViviendaAval1(response.DatosAval[0].TipoVivienda ?? '');
                setBarrioAval1(response.DatosAval[0].BarrioCol ?? '');
                setAvenidaAval1(response.DatosAval[0].Ave ?? '');
                setCalleAval1(response.DatosAval[0].Calle ?? '');
                setCasaAval1(response.DatosAval[0].CasaNo ?? '');
                setCiudadAval1(response.DatosAval[0].Ciudad ?? '');
                setDepartamentoAval1(response.DatosAval[0].Departamento ?? '');
                setEstadoCivilAval1(response.DatosAval[0].EstadoCivil ?? '');
                setReferenciaDomicilioAval1(response.DatosAval[0].ReferenciaDomicilio ?? '');
                setFijoAval1(response.DatosAval[0].TelefonoFijo ?? '');
                setMovilAval1(response.DatosAval[0].TelefonoMovil ?? '');
                setCorreoAval1(response.DatosAval[0].CorreoElectronico ?? '');
                setDependenciaAval1(response.InformacionLaboralAval[0].DependenciaTrabajo ?? '');
                setRamoAval1(response.InformacionLaboralAval[0].Ramo ?? '');
                setTelefonoLaboralAval1(response.InformacionLaboralAval[0].Telefono ?? '');
                setBarrioLaboralAval1(response.InformacionLaboralAval[0].BarrioCol ?? '');
                setAvenidaLaboralAval1(response.InformacionLaboralAval[0].Ave ?? '');
                setCalleLaboralAval1(response.InformacionLaboralAval[0].Calle ?? '');
                setCasaLaboralAval1(response.InformacionLaboralAval[0].CasaNo ?? '');
                setCiudadLaboralAval1(response.InformacionLaboralAval[0].Ciudad ?? '');
                setDepartamentoLaboralAval1(response.InformacionLaboralAval[0].Departamento ?? '');
                setSueldoMensualAval1(response.InformacionLaboralAval[0].SueldoMensual ?? '');
                setOtrosIngresosAval1(response.InformacionLaboralAval[0].OtrosIngresos ?? '');
                setSueldoNetoAval1(response.InformacionLaboralAval[0].SueldoNeto ?? '');
                setPuestoAval1(response.InformacionLaboralAval[0].Puesto ?? '');
                setTiempoLaborarAAval1(response.InformacionLaboralAval[0].TiempoLaborarAnios ?? '');
                setTiempoLaborarMAval1(response.InformacionLaboralAval[0].TiempoLaborarMeses ?? '');


                if (response.DatosAval && response.DatosAval[1]) {
                    //Aval 2
                    setIdAval2(response.DatosAval[1].AvalID ?? '');
                    setIdentidadAval2(response.DatosAval[1].NumeroIdentidad ?? '');
                    setNombresAval2(response.DatosAval[1].Nombres ?? '');
                    setApellidosAval2(response.DatosAval[1].Apellidos ?? '');
                    setNacimientoAval2(response.DatosAval[1].FechaNacimiento ?? '');
                    setProfesionAval2(response.DatosAval[1].Profesion ?? '');
                    setTipoViviendaAval2(response.DatosAval[1].TipoVivienda ?? '');
                    setBarrioAval2(response.DatosAval[1].BarrioCol ?? '');
                    setAvenidaAval2(response.DatosAval[1].Ave ?? '');
                    setCalleAval2(response.DatosAval[1].Calle ?? '');
                    setCasaAval2(response.DatosAval[1].CasaNo ?? '');
                    setCiudadAval2(response.DatosAval[1].Ciudad ?? '');
                    setDepartamentoAval2(response.DatosAval[1].Departamento ?? '');
                    setEstadoCivilAval2(response.DatosAval[1].EstadoCivil ?? '');
                    setReferenciaDomicilioAval2(response.DatosAval[1].ReferenciaDomicilio ?? '');
                    setFijoAval2(response.DatosAval[1].TelefonoFijo ?? '');
                    setMovilAval2(response.DatosAval[1].TelefonoMovil ?? '');
                    setCorreoAval2(response.DatosAval[1].CorreoElectronico ?? '');
                    setDependenciaAval2(response.InformacionLaboralAval[1].DependenciaTrabajo ?? '');
                    setRamoAval2(response.InformacionLaboralAval[1].Ramo ?? '');
                    setTelefonoLaboralAval2(response.InformacionLaboralAval[1].Telefono ?? '');
                    setBarrioLaboralAval2(response.InformacionLaboralAval[1].BarrioCol ?? '');
                    setAvenidaLaboralAval2(response.InformacionLaboralAval[1].Ave ?? '');
                    setCalleLaboralAval2(response.InformacionLaboralAval[1].Calle ?? '');
                    setCasaLaboralAval2(response.InformacionLaboralAval[1].CasaNo ?? '');
                    setCiudadLaboralAval2(response.InformacionLaboralAval[1].Ciudad ?? '');
                    setDepartamentoLaboralAval2(response.InformacionLaboralAval[1].Departamento ?? '');
                    setSueldoMensualAval2(response.InformacionLaboralAval[1].SueldoMensual ?? '');
                    setOtrosIngresosAval2(response.InformacionLaboralAval[1].OtrosIngresos ?? '');
                    setSueldoNetoAval2(response.InformacionLaboralAval[1].SueldoNeto ?? '');
                    setPuestoAval2(response.InformacionLaboralAval[1].Puesto ?? '');
                    setTiempoLaborarAAval2(response.InformacionLaboralAval[1].TiempoLaborarAnios ?? '');
                    setTiempoLaborarMAval2(response.InformacionLaboralAval[1].TiempoLaborarMeses ?? '');
                }
            }

            //TRANSFERENCIA DE PAGO DEL MONTO APROBADO A CUENTA BANCARIA
            if (response.TransferenciaPago && response.TransferenciaPago[0]) {
                response.TransferenciaPago[0].TipoCuenta !== undefined && setTipoCuenta(response.TransferenciaPago[0].TipoCuenta);
                response.TransferenciaPago[0].Banco !== undefined && setNombreBanco(response.TransferenciaPago[0].Banco);
                response.TransferenciaPago[0].NoCuenta !== undefined && setNoCuenta(response.TransferenciaPago[0].NoCuenta);
            }

            //Deudas A Consolidar
            //fila 1
            if (response.DeudasConsolidar && response.DeudasConsolidar[0]) {
                response.DeudasConsolidar[0].DeudaID !== undefined && setIdFila1(response.DeudasConsolidar[0].DeudaID);
                response.DeudasConsolidar[0].InstitucionFinanciera !== undefined && setInstitucionNombre1(response.DeudasConsolidar[0].InstitucionFinanciera);
                response.DeudasConsolidar[0].MontoLempiras !== undefined && setMontoLempiras1(response.DeudasConsolidar[0].MontoLempiras);
                response.DeudasConsolidar[0].MontoDolares !== undefined && setMontoDolares1(response.DeudasConsolidar[0].MontoDolares);
                response.DeudasConsolidar[0].TotalLempiras !== undefined && setTotalLempiras1(response.DeudasConsolidar[0].TotalLempiras);
                response.DeudasConsolidar[0].ConsolidacionTotal !== undefined && setConsolidacionTotal1(response.DeudasConsolidar[0].ConsolidacionTotal);
                response.DeudasConsolidar[0].ConsolidacionParcial !== undefined && setConsolidacionParcial1(response.DeudasConsolidar[0].ConsolidacionParcial);
            }
            //fila 2
            if (response.DeudasConsolidar && response.DeudasConsolidar[1]) {
                setIdFila2(response.DeudasConsolidar[1].DeudaID ?? '');
                setInstitucionNombre2(response.DeudasConsolidar[1].InstitucionFinanciera ?? '');
                setMontoLempiras2(response.DeudasConsolidar[1].MontoLempiras ?? '');
                setMontoDolares2(response.DeudasConsolidar[1].MontoDolares ?? '');
                setTotalLempiras2(response.DeudasConsolidar[1].TotalLempiras ?? '');
                setConsolidacionTotal2(response.DeudasConsolidar[1].ConsolidacionTotal ?? '');
                setConsolidacionParcial2(response.DeudasConsolidar[1].ConsolidacionParcial ?? '');
            }

            //fila 3
            if (response.DeudasConsolidar && response.DeudasConsolidar[2]) {
                setIdFila3(response.DeudasConsolidar[2].DeudaID ?? '');
                setInstitucionNombre3(response.DeudasConsolidar[2].InstitucionFinanciera ?? '');
                setMontoLempiras3(response.DeudasConsolidar[2].MontoLempiras ?? '');
                setMontoDolares3(response.DeudasConsolidar[2].MontoDolares ?? '');
                setTotalLempiras3(response.DeudasConsolidar[2].TotalLempiras ?? '');
                setConsolidacionTotal3(response.DeudasConsolidar[2].ConsolidacionTotal ?? '');
                setConsolidacionParcial3(response.DeudasConsolidar[2].ConsolidacionParcial ?? '');
            }

            //fila 4
            if (response.DeudasConsolidar && response.DeudasConsolidar[3]) {
                setIdFila4(response.DeudasConsolidar[3].DeudaID ?? '');
                setInstitucionNombre4(response.DeudasConsolidar[3].InstitucionFinanciera ?? '');
                setMontoLempiras4(response.DeudasConsolidar[3].MontoLempiras ?? '');
                setMontoDolares4(response.DeudasConsolidar[3].MontoDolares ?? '');
                setTotalLempiras4(response.DeudasConsolidar[3].TotalLempiras ?? '');
                setConsolidacionTotal4(response.DeudasConsolidar[3].ConsolidacionTotal ?? '');
                setConsolidacionParcial4(response.DeudasConsolidar[3].ConsolidacionParcial ?? '');
            }

            //fila 5
            if (response.DeudasConsolidar && response.DeudasConsolidar[4]) {
                setIdFila5(response.DeudasConsolidar[4].DeudaID ?? '');
                setInstitucionNombre5(response.DeudasConsolidar[4].InstitucionFinanciera ?? '');
                setMontoLempiras5(response.DeudasConsolidar[4].MontoLempiras ?? '');
                setMontoDolares5(response.DeudasConsolidar[4].MontoDolares ?? '');
                setTotalLempiras5(response.DeudasConsolidar[4].TotalLempiras ?? '');
                setConsolidacionTotal5(response.DeudasConsolidar[4].ConsolidacionTotal ?? '');
                setConsolidacionParcial5(response.DeudasConsolidar[4].ConsolidacionParcial ?? '');
            }

            /*if (response.TotalesPrestamo[0]) {
                //fila 6 totales
                setTotalMontoLempiras1(response.TotalesPrestamo[0].TotalMontoLempiras ?? '');
                setTotalMontoDolares1(response.TotalesPrestamo[0].TotalMontoDolares ?? '');
                setTotalTotalLempiras1(response.TotalesPrestamo[0].TotalTotalLempiras ?? '');
                setTotalConsolidacionTotal1(response.TotalesPrestamo[0].TotalConsolidacionTotal ?? '');
                setTotalConsolidacionParcial1(response.TotalesPrestamo[0].TotalConsolidacionParcial ?? '');
            }*/

            /*if (response.TotalesMontoAFavor[0]) {
                //fila 7 total monto a favor
                setTotalMontoLempiras2(response.TotalesMontoAFavor[0].TotalMontoLempiras ?? '');
                setTotalMontoDolares2(response.TotalesMontoAFavor[0].TotalMontoDolares ?? '');
                setTotalTotalLempiras2(response.TotalesMontoAFavor[0].TotalTotalLempiras ?? '');
                setTotalConsolidacionTotal2(response.TotalesMontoAFavor[0].TotalConsolidacionTotal ?? '');
                setTotalConsolidacionParcial2(response.TotalesMontoAFavor[0].TotalConsolidacionParcial ?? '');
            }*/

        }
        fetchData();
    }, []);

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: '#6BC5D0',
            color: theme.palette.common.white,
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14,
        },
    }));

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
        // hide last border
        '&:last-child td, &:last-child th': {
            border: 0,
        },
    }));

    const [errors, setErrors] = useState({});
    const [selectedFile, setSelectedFile] = useState(null);
    const [open, setOpen] = React.useState(false);
    const [openRechazar, setOpenRechazar] = React.useState(false);

    const handleClose = () => {
        setOpen(false);
    };

    const handleOpen = () => {
        setOpen(true);
    };

    const handleCloseRechazar = () => {
        setOpenRechazar(false);
    };

    const handleOpenRechazar = () => {
        setOpenRechazar(true);
    };

    return (<>
        <div id="my-container">
            <Container style={{ marginTop: 100 }} >
                <Stack direction="row">
                    <Grid spacing={2} container>
                        <Grid item xs={10} md={2.2}>
                            <img style={{ width: 200, height: 'auto' }} src={logoblack} />
                        </Grid>
                        <Grid style={{ textAlign: 'center' }} item xs={4} md={5.8}>
                            <h3>DPP-F-04.2</h3>
                            <h1>SOLICITUD DE PRÉSTAMO</h1>
                        </Grid>
                        <Grid item xs={4} md={4}>
                            <Stack>
                                <Box>
                                    <label style={{ marginRight: 10 }}>No. Solicitud: </label>
                                    {/*<TextField id="NoSolicitud" variant="standard" InputProps={{ readOnly: true }} />*/}
                                    <TextField id="NoSolicitud" variant="standard" value={numeroSolicitud} InputProps={{ readOnly: true }} />
                                </Box>
                                <Box>
                                    <label style={{ marginRight: 10, visibility: 'hidden' }}>No. Cotizante:</label>
                                    <TextField id="NoCotizante" variant="standard" value={numeroCotizante} InputProps={{ readOnly: true }} style={{ visibility: 'hidden' }} />
                                </Box>
                            </Stack>

                        </Grid>
                    </Grid>
                </Stack>

                <Stack direction="row" alignItems="center">
                    <label style={{ marginRight: 10 }}><strong>TIPO DE PRÉSTAMO:</strong></label>
                    <label>{tipoPrestamo}</label>
                </Stack>
                <Divider />
                <Grid item marginTop={3}>
                    {estadoSolicitud === 5 ? (
                        <>
                            <Typography variant="h6" style={{ color: 'green' }}>
                                <CheckCircle fontSize="small" /> Solicitud Aprobada
                            </Typography>
                            <InputLabel><b>Observación:</b> {observacion}</InputLabel>
                        </>
                    ) : estadoSolicitud === 7 ? (
                        <>
                            <Typography variant="h6" style={{ color: 'orange' }}>
                                <Cancel fontSize="small" /> Solicitud Aprobada Sujeta A Cambios
                            </Typography>
                            <InputLabel><b>Observación:</b> {observacion}</InputLabel>
                        </>
                    ) : estadoSolicitud === 6 ? (
                        <>
                            <Typography variant="h6" style={{ color: 'var(--color-brand-secondary)' }}>
                                <Cancel fontSize="small" /> Rechazado
                            </Typography>
                            <InputLabel><b>Observación:</b> {observacion}</InputLabel>
                        </>
                    ) : (<></>)}
                </Grid>

                <Stack direction="row" alignItems="center">
                    <h3 style={{ marginRight: 10 }}>MONTO SOLICITADO:</h3>
                    <FormControl sx={{ m: 1, width: 200 }}>
                        <TextField id="montosolicitado" variant="standard" value={montoSolicitado} InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    L.
                                </InputAdornment>
                            ),
                            readOnly: true
                        }}
                        />
                    </FormControl>
                </Stack>

                <Box>
                    <Stack direction="row">
                        <h3 >I. DATOS DEL SOLICITANTE</h3>
                    </Stack>

                    <Stack direction="row">
                        <Grid container spacing={1}>
                            <FormControl sx={{ m: 1, width: 300 }}>
                                <TextField
                                    id="solicitanteIdentidad"
                                    label="Numero de Identidad"
                                    value={identidadSolicitante}
                                    variant="standard"
                                    InputProps={{ readOnly: true }}
                                />
                            </FormControl>
                            <FormControl sx={{ m: 1, width: 300 }}>
                                <TextField
                                    id="solicitanteNombres"
                                    label="Nombres"
                                    value={nombresSolicitante}
                                    variant="standard"
                                    InputProps={{ readOnly: true }}
                                />
                            </FormControl>
                            <FormControl sx={{ m: 1, width: 300 }}>
                                <TextField id="solicitanteApellidos" value={apellidosSolicitante} label="Apellidos" variant="standard" InputProps={{ readOnly: true }} />
                            </FormControl>
                            <FormControl sx={{ m: 1, width: 300 }}>
                                <TextField id="solicitanteNacimiento" value={nacimientoSolicitante} label="Fecha De Nacimiento"
                                    variant="outlined"
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <CalendarIcon />
                                            </InputAdornment>
                                        ),
                                        readOnly: true
                                    }}
                                />
                            </FormControl>
                            <FormControl sx={{ m: 1, width: 400 }}>
                                <TextField id="solicitanteProfesion" value={profesionSolicitante} label="Profesión u Oficio" variant="standard" InputProps={{ readOnly: true }} />
                            </FormControl>
                        </Grid>

                    </Stack>

                    <Stack className={classes.above} direction="row" >
                        <Grid container>
                            <Stack direction="row" alignItems="center">
                                <label style={{ marginRight: 10 }}><strong>TIPO DE VIVIENDA:</strong></label>
                                <label>{tipoViviendaSolicitante}</label>
                            </Stack>
                        </Grid>
                    </Stack>

                    <Stack className={classes.above} direction="row" marginTop={3}>
                        <Grid Container>

                            <Box>
                                <label><strong>Dirección</strong></label>
                                <Box>
                                    <Stack direction="row">
                                        <Box sx={{ width: 200 }}>
                                            <TextField id="solicitanteBarrio" value={barrioSolicitante} label="Barrio/Col." variant="standard"
                                                InputProps={{ readOnly: true }} />
                                        </Box>

                                        <Box sx={{ width: 200 }}>
                                            <TextField id="solicitanteAve" value={avenidaSolicitante} label="Ave." variant="standard"
                                                InputProps={{ readOnly: true }} />
                                        </Box>

                                        <Box sx={{ width: 200 }}>
                                            <TextField id="solicitanteCalle" value={calleSolicitante} label="Calle" variant="standard"
                                                InputProps={{ readOnly: true }} />
                                        </Box>

                                        <Box sx={{ width: 200 }}>
                                            <TextField id="solicitanteCasa" value={casaSolicitante} label="Casa No." variant="standard"
                                                InputProps={{ readOnly: true }} />
                                        </Box>

                                        <Box sx={{ width: 200 }}>
                                            <TextField id="solicitanteCiudad" value={ciudadSolicitante} label="Ciudad" variant="standard"
                                                InputProps={{ readOnly: true }} />
                                        </Box>

                                        <Box sx={{ width: 220 }}>
                                            <TextField id="solicitanteDepartamento" value={departamentoSolicitante} label="Departamento" variant="standard"
                                                InputProps={{ readOnly: true }} />
                                        </Box>

                                    </Stack>
                                </Box>
                            </Box>
                            <Box>
                                <FormControl sx={{ m: 1, width: 300 }} >
                                    <TextField id="estadocivilSolicitante" value={estadoCivilSolicitante} label="Estado Civil" variant="standard"
                                        InputProps={{ readOnly: true }} />
                                </FormControl>

                                <FormControl sx={{ m: 1, width: 800 }}>
                                    <TextField id="solicitanteReferenciaDomicilio" value={referenciaDomicilioSolicitante} label="Referencia Domicilio" variant="standard"
                                        InputProps={{ readOnly: true }} />
                                </FormControl>
                                <FormControl sx={{ m: 1, width: 300 }}>
                                    <TextField id="solicitanteFijo" value={fijoSolicitante} label="Teléfono Fijo" variant="standard"
                                        InputProps={{ readOnly: true }} />
                                </FormControl>
                                <FormControl sx={{ m: 1, width: 300 }} >
                                    <TextField id="solicitanteMovil" value={movilSolicitante} label="Teléfono Móvil" variant="standard"
                                        InputProps={{ readOnly: true }} />
                                </FormControl>
                                <FormControl sx={{ m: 1, width: 300 }} >
                                    <TextField id="solicitanteCorreo" value={correoSolicitante} label="Correo Electrónico" variant="standard"
                                        InputProps={{ readOnly: true }} />
                                </FormControl>
                            </Box>
                        </Grid>
                    </Stack>
                </Box>
                <Divider />
                {sessi.sessionData.estado !== "JUBILADO" && (
                    <Box>
                        <Stack direction="row">
                            <h3 >II. INFORMACIÓN LABORAL (participantes activos)</h3>
                        </Stack>

                        <Stack direction="row">
                            <Grid container>
                                <FormControl sx={{ m: 1, width: 350 }}>
                                    <TextField id="laboralDependencia" value={dependenciaSolicitante} label="Dependencia donde Trabaja" variant="standard"
                                        InputProps={{ readOnly: true }} />
                                </FormControl>
                                <FormControl sx={{ m: 1, width: 350 }}>
                                    <TextField id="laboralRamo" value={ramoSolicitante} label="Ramo" variant="standard"
                                        InputProps={{ readOnly: true }} />
                                </FormControl>
                                <FormControl sx={{ m: 1, width: 350 }}>
                                    <TextField id="laboralTelefono" value={telefonoLaboralSolicitante} label="Teléfono" variant="standard" inputProps={{ maxLength: 8 }}
                                        InputProps={{ readOnly: true }} />
                                </FormControl>
                                <Box>
                                    <label><strong>Dirección</strong></label>
                                    <Box>
                                        <Stack direction="row">
                                            <Box sx={{ width: 200 }}>
                                                <TextField id="laboralBarrio" value={barrioLaboralSolicitante} label="Barrio/Col." variant="standard"
                                                    InputProps={{ readOnly: true }} />
                                            </Box>

                                            <Box sx={{ width: 200 }}>
                                                <TextField id="laboralAve" value={avenidaLaboralSolicitante} label="Ave." variant="standard"
                                                    InputProps={{ readOnly: true }} />
                                            </Box>

                                            <Box sx={{ width: 200 }}>
                                                <TextField id="laboralCalle" value={calleLaboralSolicitante} label="Calle" variant="standard"
                                                    InputProps={{ readOnly: true }} />
                                            </Box>

                                            <Box sx={{ width: 200 }}>
                                                <TextField id="laboralCasa" value={casaLaboralSolicitante} label="Casa No." variant="standard"
                                                    InputProps={{ readOnly: true }} />
                                            </Box>

                                            <Box sx={{ width: 200 }}>
                                                <TextField id="laboralCiudad" value={ciudadLaboralSolicitante} label="Ciudad" variant="standard"
                                                    InputProps={{ readOnly: true }} />
                                            </Box>

                                            <Box sx={{ width: 200 }}>
                                                <TextField id="laboralDepartamento" value={departamentoLaboralSolicitante} label="Departamento" variant="standard"
                                                    InputProps={{ readOnly: true }} />
                                            </Box>
                                        </Stack>
                                    </Box>
                                </Box>

                                <FormControl sx={{ m: 1, width: 200 }}>
                                    <TextField id="sueldoMensualsoli" value={sueldoMensualSolicitante} label="Sueldo Mensual" variant="standard" InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                L.
                                            </InputAdornment>
                                        ),
                                        readOnly: true
                                    }}
                                    />
                                </FormControl>
                                <FormControl sx={{ m: 1, width: 300 }}>
                                    <TextField id="otrosIngresossoli" value={otrosIngresosSolicitante} label="Otros Ingresos (detalle)" variant="standard" InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                L.
                                            </InputAdornment>
                                        ),
                                        readOnly: true
                                    }}
                                    />
                                </FormControl>
                                <FormControl sx={{ m: 1, width: 200 }}>
                                    <TextField id="sueldoNetosoli" value={sueldoNetoSolicitante} label="Sueldo Neto" variant="standard" InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                L.
                                            </InputAdornment>
                                        ),
                                        readOnly: true
                                    }}
                                    />
                                </FormControl>
                                <FormControl sx={{ m: 1, width: 300 }}>
                                    <TextField id="laboralPuesto" value={puestoSolicitante} label="Puesto" variant="standard"
                                        InputProps={{ readOnly: true }} />
                                </FormControl>
                                <Box>

                                    <Box>
                                        <label><strong>Tiempo Laborar</strong></label>
                                    </Box>
                                    <FormControl sx={{ m: 1, width: 300 }}>
                                        <TextField id="laboralYears" value={tiempoLaborarASolicitante} label="Años" variant="standard"
                                            InputProps={{ readOnly: true }} />
                                    </FormControl>

                                    <FormControl sx={{ m: 1, width: 300 }}>
                                        <TextField id="laboralMeses" value={tiempoLaborarMSolicitante} label="Meses" variant="standard"
                                            InputProps={{ readOnly: true }} />
                                    </FormControl>
                                </Box>
                            </Grid>

                        </Stack>
                    </Box>)}
                <Box marginTop={3}>
                    <h3>IDENTIDAD DEL SOLICITANTE EN FORMATO PDF</h3>
                    <Box display="flex" alignItems="center" justifyContent="center">
                        <Box
                            style={{
                                padding: '50px',
                                width: '700px',
                                textAlign: 'center',
                                borderColor: 'gray',
                                borderRadius: 5,
                                borderWidth: 5,
                                borderStyle: 'dashed',
                            }}
                        >
                            <img src={pdficon} alt="Download PDF Icon" style={{ width: 75, height: 77, color: 'gray' }} />
                            <br />
                            <Button
                                variant="contained"
                                onClick={handleButtonIdentidad}
                                style={{ marginTop: '10px', backgroundColor: '#ECECEC' }}
                            >
                                Ver Archivo PDF
                            </Button>
                            <p>Haz clic en el botón para visualizar la identidad del solicitante en PDF</p>
                            <Backdrop open={openPdf} onClick={handleCloseIdentidad} style={{ zIndex: 1 }}>
                                <Dialog
                                    open={openPdf}
                                    onClose={handleCloseIdentidad}
                                    maxWidth="md"
                                    fullWidth
                                >
                                    <DialogTitle textAlign={'center'}>Identidad Del Solicitante</DialogTitle>
                                    <DialogContent>
                                        {pdfUrl && (
                                            <iframe
                                                src={pdfUrl}
                                                width="100%"
                                                height="600px"
                                            ></iframe>
                                        )}
                                    </DialogContent>
                                </Dialog>
                            </Backdrop>
                        </Box>
                    </Box>
                </Box>
                <Divider style={{ marginTop: 5 }} />

                <Stack direction="row">
                    <h3 >III. REFERENCIAS PERSONALES</h3>
                </Stack>

                <Stack>
                    <Grid>
                        <Box>
                            <TableContainer component={Paper}>
                                <Table aria-label="customized table">
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell>#</StyledTableCell>
                                            <StyledTableCell sx={{ m: 1, width: 50 }} align="center">Nombre</StyledTableCell>
                                            <StyledTableCell sx={{ m: 1, width: 200 }} align="center">Parentesco</StyledTableCell>
                                            <StyledTableCell sx={{ m: 1, width: 300 }} align="center">Dirección</StyledTableCell>
                                            <StyledTableCell sx={{ m: 1, width: 200 }} align="center">Teléfono</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        <StyledTableRow key={1}>
                                            <StyledTableCell component="th" scope="row">1.</StyledTableCell>
                                            <StyledTableCell align="right">
                                                <FormControl sx={{ m: 1, width: 200 }}>
                                                    <TextField id="referencia1Nombres" value={referencia1} variant="standard" InputProps={{ readOnly: true }} />
                                                </FormControl>
                                            </StyledTableCell>
                                            <StyledTableCell align="right">
                                                <FormControl sx={{ m: 1, width: 200 }}>
                                                    <TextField id="referencia1Parentesco" value={parentescoReferencia1} variant="standard" InputProps={{ readOnly: true }} />
                                                </FormControl>
                                            </StyledTableCell>
                                            <StyledTableCell align="right">
                                                <FormControl sx={{ m: 1, width: 300 }}>
                                                    <TextField id="referencia1Direccion" value={direccionReferencia1} variant="standard" InputProps={{ readOnly: true }} />
                                                </FormControl>
                                            </StyledTableCell>
                                            <StyledTableCell align="right">
                                                <FormControl sx={{ m: 1, width: 200 }}>
                                                    <TextField id="referencia1Telefono" value={telefonoReferencia1} variant="standard" InputProps={{ readOnly: true }} />
                                                </FormControl>
                                            </StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow key={2}>
                                            <StyledTableCell component="th" scope="row">2.</StyledTableCell>
                                            <StyledTableCell align="right">
                                                <FormControl sx={{ m: 1, width: 200 }}>
                                                    <TextField id="referencia2Nombres" value={referencia2} variant="standard" InputProps={{ readOnly: true }} />
                                                </FormControl>
                                            </StyledTableCell>
                                            <StyledTableCell align="right">
                                                <FormControl sx={{ m: 1, width: 200 }}>
                                                    <TextField id="referencia2Parentesco" value={parentescoReferencia2} variant="standard" InputProps={{ readOnly: true }} />
                                                </FormControl>
                                            </StyledTableCell>
                                            <StyledTableCell align="right">
                                                <FormControl sx={{ m: 1, width: 300 }}>
                                                    <TextField id="referencia2Direccion" value={direccionReferencia2} variant="standard" InputProps={{ readOnly: true }} />
                                                </FormControl>
                                            </StyledTableCell>
                                            <StyledTableCell align="right">
                                                <FormControl sx={{ m: 1, width: 200 }}>
                                                    <TextField id="referencia2Telefono" value={telefonoReferencia2} variant="standard" InputProps={{ readOnly: true }} />
                                                </FormControl>
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </Grid>
                </Stack>
                <Divider style={{ marginTop: 10 }} />

                {(tipoPrestamo === "Con Aval" || tipoPrestamo === "Consolidacion de Deuda" || tipoPrestamo === "all") && <>
                    <AvalPrecargado
                        identidad={identidadAval1}
                        nombres={nombresAval1}
                        apellidos={apellidosAval1}
                        nacimiento={nacimientoAval1}
                        profesion={profesionAval1}
                        vivienda={tipoViviendaAval1}
                        ave={avenidaAval1}
                        barrio={barrioAval1}
                        calle={calleAval1}
                        casa={casaAval1}
                        ciudad={ciudadAval1}
                        departamento={departamentoAval1}
                        estado={estadoCivilAval1}
                        referenciadomicilio={referenciaDomicilioAval1}
                        fijo={fijoAval1}
                        movil={movilAval1}
                        correo={correoAval1}
                        dependencia={dependenciaAval1}
                        ramo={ramoAval1}
                        telefonolaboral={telefonoLaboralAval1}
                        barriolaboral={barrioLaboralAval1}
                        avenidalaboral={avenidaLaboralAval1}
                        callelaboral={calleLaboralAval1}
                        casalaboral={casaLaboralAval1}
                        ciudadlaboral={ciudadLaboralAval1}
                        departamentolaboral={departamentoLaboralAval1}
                        sueldomensual={sueldoMensualAval1}
                        otrosingresos={otrosIngresosAval1}
                        sueldoneto={sueldoNetoAval1}
                        puesto={puestoAval1}
                        tiempolaborarA={tiempoLaborarAAval1}
                        tiempolaborarM={tiempoLaborarMAval1}
                        icono={pdficon}
                        handleDescargar={handleButtonAval1}
                        openAval1={openPdfAval1}
                        closeAval1={handleCloseAval1}
                        pdfUrlAval1={pdfUrlAval1}
                    />
                    <Divider />
                </>
                }
                {(tipoPrestamo === "Con Aval" || tipoPrestamo === "Consolidacion de Deuda" || tipoPrestamo === "all") && <>
                    <Aval2Precargado
                        identidad={identidadAval2}
                        nombres={nombresAval2}
                        apellidos={apellidosAval2}
                        nacimiento={nacimientoAval2}
                        profesion={profesionAval2}
                        vivienda={tipoViviendaAval2}
                        ave={avenidaAval2}
                        barrio={barrioAval2}
                        calle={calleAval2}
                        casa={casaAval2}
                        ciudad={ciudadAval2}
                        departamento={departamentoAval2}
                        estado={estadoCivilAval2}
                        referenciadomicilio={referenciaDomicilioAval2}
                        fijo={fijoAval2}
                        movil={movilAval2}
                        correo={correoAval2}
                        dependencia={dependenciaAval2}
                        ramo={ramoAval2}
                        telefonolaboral={telefonoLaboralAval2}
                        barriolaboral={barrioLaboralAval2}
                        avenidalaboral={avenidaLaboralAval2}
                        callelaboral={calleLaboralAval2}
                        casalaboral={casaLaboralAval2}
                        ciudadlaboral={ciudadLaboralAval2}
                        departamentolaboral={departamentoLaboralAval2}
                        sueldomensual={sueldoMensualAval2}
                        otrosingresos={otrosIngresosAval2}
                        sueldoneto={sueldoNetoAval2}
                        puesto={puestoAval2}
                        tiempolaborarA={tiempoLaborarAAval2}
                        tiempolaborarM={tiempoLaborarMAval2}
                        icono={pdficon}
                        handleDescargar={handleButtonAval2}
                        openAval2={openPdfAval2}
                        closeAval2={handleCloseAval2}
                        pdfUrlAval2={pdfUrlAval2}
                    />
                    <Divider />
                </>}


                <Stack direction="row">
                    <Box>
                        <Stack>
                            <h3 >VIII. TRANSFERENCIA DE PAGO DEL MONTO APROBADO A CUENTA BANCARIA</h3>
                        </Stack>
                        <h4>INFORMACIÓN DEL BANCO</h4>
                        <Grid container>
                            <Stack direction="row">
                                <FormControl sx={{ m: 1, width: 300 }}>
                                    <label><strong>Tipo De Cuenta:</strong></label>
                                    <label>{tipoCuenta}</label>
                                </FormControl>
                                <FormControl sx={{ m: 1, width: 300 }}>
                                    <TextField id="solicitanteBancoCuenta" value={nombreBanco} label="Nombre del Banco" variant="standard" InputProps={{ readOnly: true }} />
                                </FormControl>
                                <FormControl sx={{ m: 1, width: 300 }}>
                                    <TextField id="nocuenta" value={noCuenta} label="No. de Cuenta" variant="standard" InputProps={{ readOnly: true }} />
                                </FormControl>
                            </Stack>
                        </Grid>
                    </Box>
                </Stack>
                <Divider></Divider>
                <Box>
                    <Stack direction="row">
                        <Grid>
                            <Stack>
                                <h3>IX. DEUDAS A CONSOLIDAR</h3>
                            </Stack>
                            <Box>
                                <TableContainer component={Paper}>
                                    <Table aria-label="customized table">
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell style={{ width: 100 }} rowSpan={2} align="center">Institución Financiera</StyledTableCell>
                                                <TableCell colSpan={3} align="center"> Monto</TableCell>
                                                <StyledTableCell colSpan={2} align="center">Consolidación</StyledTableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell align="center" sx={{ m: 1, width: 150 }}>Lempiras</TableCell>
                                                <TableCell align="center" sx={{ m: 1, width: 150 }}>Dólares</TableCell>
                                                <TableCell align="center" sx={{ m: 1, width: 150 }}>Total Lempiras</TableCell>
                                                <StyledTableCell align="center" sx={{ m: 1, width: 150 }}>Total</StyledTableCell>
                                                <StyledTableCell align="center" sx={{ m: 1, width: 150 }}>Parcial</StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            <TableRow>
                                                <StyledTableCell component="th" scope="row">
                                                    <FormControl sx={{ m: 1, width: 300 }}>
                                                        <TextField id="solicitanteBancoCuentaConsolidar1" value={institucionNombre1} label="Institución Financiera" variant="standard" InputProps={{ readOnly: true }} />
                                                    </FormControl>
                                                </StyledTableCell>
                                                <TableCell align="right">
                                                    <FormControl sx={{ m: 1, width: 100 }}>
                                                        <TextField
                                                            id="lempirasconsolidar1"
                                                            variant="standard"
                                                            value={montoLempiras1}
                                                            InputProps={{
                                                                startAdornment: <InputAdornment position="start">L.</InputAdornment>,
                                                                readOnly: true
                                                            }}
                                                        />
                                                    </FormControl>
                                                </TableCell>
                                                <TableCell align="right">
                                                    <FormControl sx={{ m: 1, width: 100 }}>
                                                        <TextField
                                                            id="dolaresconsolidar1"
                                                            variant="standard"
                                                            value={montoDolares1}
                                                            InputProps={{
                                                                startAdornment: <InputAdornment position="start">$.</InputAdornment>,
                                                                readOnly: true
                                                            }}
                                                        />
                                                    </FormControl>
                                                </TableCell>
                                                <TableCell align="right">
                                                    <FormControl sx={{ m: 1, width: 100 }}>
                                                        <TextField
                                                            id="total-lempiras-consolidar-1"
                                                            value={totalLempiras1}
                                                            variant="standard"
                                                            InputProps={{ readOnly: true, startAdornment: <InputAdornment position="start">L.</InputAdornment> }}
                                                        />
                                                    </FormControl>
                                                </TableCell>
                                                <TableCell align="right">
                                                    <FormControl sx={{ m: 1, width: 100 }}>
                                                        <TextField
                                                            id="consolidaciontotal1"
                                                            value={consolidacionTotal1}
                                                            variant="standard"
                                                            InputProps={{ readOnly: true, startAdornment: <InputAdornment position="start">L.</InputAdornment> }}
                                                        />
                                                    </FormControl>
                                                </TableCell>
                                                <TableCell align="right">
                                                    <FormControl sx={{ m: 1, width: 100 }}>
                                                        <TextField
                                                            id="consolidacionparcial1"
                                                            value={consolidacionParcial1}
                                                            variant="standard"
                                                            InputProps={{ startAdornment: <InputAdornment position="start">L.</InputAdornment>, readOnly: true }}
                                                        />
                                                    </FormControl>
                                                </TableCell>
                                            </TableRow>

                                            {institucionNombre2 !== "" && montoLempiras2 !== "" && montoDolares2 !== "" && (
                                                <TableRow>
                                                    <StyledTableCell component="th" scope="row">
                                                        <FormControl sx={{ m: 1, width: 300 }}>
                                                            <TextField id="solicitanteBancoCuentaConsolidar2" value={institucionNombre2} label="Institución Financiera" variant="standard" InputProps={{ readOnly: true }} />
                                                        </FormControl>
                                                    </StyledTableCell>
                                                    <TableCell align="right">
                                                        <FormControl sx={{ m: 1, width: 100 }}>
                                                            <TextField
                                                                id="lempirasconsolidar2"
                                                                variant="standard"
                                                                value={montoLempiras2}
                                                                InputProps={{
                                                                    startAdornment: <InputAdornment position="start">L.</InputAdornment>,
                                                                    readOnly: true
                                                                }}
                                                            />
                                                        </FormControl>
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        <FormControl sx={{ m: 1, width: 100 }}>
                                                            <TextField
                                                                id="dolaresconsolidar2"
                                                                value={montoDolares2}
                                                                variant="standard"
                                                                InputProps={{
                                                                    startAdornment: <InputAdornment position="start">$.</InputAdornment>,
                                                                    readOnly: true
                                                                }}
                                                            />
                                                        </FormControl>
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        <FormControl sx={{ m: 1, width: 100 }}>
                                                            <TextField
                                                                id="total-lempiras-consolidar-2"
                                                                value={totalLempiras2}
                                                                variant="standard"
                                                                InputProps={{ readOnly: true, startAdornment: <InputAdornment position="start">L.</InputAdornment> }}
                                                            />
                                                        </FormControl>
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        <FormControl sx={{ m: 1, width: 100 }}>
                                                            <TextField
                                                                id="consolidaciontotal2"
                                                                value={consolidacionTotal2}
                                                                variant="standard"
                                                                InputProps={{ readOnly: true, startAdornment: <InputAdornment position="start">L.</InputAdornment> }}
                                                            />
                                                        </FormControl>
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        <FormControl sx={{ m: 1, width: 100 }}>
                                                            <TextField
                                                                id="consolidacionparcial2"
                                                                value={consolidacionParcial2}
                                                                variant="standard"
                                                                InputProps={{ startAdornment: <InputAdornment position="start">L.</InputAdornment>, readOnly: true }}
                                                            />
                                                        </FormControl>
                                                    </TableCell>
                                                </TableRow>)}

                                            {institucionNombre3 !== "" && montoLempiras3 !== "" && montoDolares3 !== "" && (
                                                <TableRow>
                                                    <StyledTableCell component="th" scope="row">
                                                        <FormControl sx={{ m: 1, width: 300 }}>
                                                            <TextField id="solicitanteBancoCuentaConsolidar3" value={institucionNombre3} label="Institución Financiera" variant="standard" InputProps={{ readOnly: true }} />
                                                        </FormControl>
                                                    </StyledTableCell>
                                                    <TableCell align="right">
                                                        <FormControl sx={{ m: 1, width: 100 }}>
                                                            <TextField
                                                                id="lempirasconsolidar3"
                                                                value={montoLempiras3}
                                                                variant="standard"
                                                                InputProps={{
                                                                    startAdornment: <InputAdornment position="start">L.</InputAdornment>,
                                                                    readOnly: true
                                                                }}
                                                            />
                                                        </FormControl>
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        <FormControl sx={{ m: 1, width: 100 }}>
                                                            <TextField
                                                                id="dolaresconsolidar3"
                                                                value={montoDolares3}
                                                                variant="standard"
                                                                InputProps={{
                                                                    startAdornment: <InputAdornment position="start">$.</InputAdornment>,
                                                                    readOnly: true
                                                                }}
                                                            />
                                                        </FormControl>
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        <FormControl sx={{ m: 1, width: 100 }}>
                                                            <TextField
                                                                id="total-lempiras-consolidar-3"
                                                                value={totalLempiras3}
                                                                variant="standard"
                                                                InputProps={{ readOnly: true, startAdornment: <InputAdornment position="start">L.</InputAdornment> }}
                                                            />
                                                        </FormControl>
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        <FormControl sx={{ m: 1, width: 100 }}>
                                                            <TextField
                                                                id="consolidaciontotal3"
                                                                value={consolidacionTotal3}
                                                                variant="standard"
                                                                InputProps={{ readOnly: true, startAdornment: <InputAdornment position="start">L.</InputAdornment> }}
                                                            />
                                                        </FormControl>
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        <FormControl sx={{ m: 1, width: 100 }}>
                                                            <TextField
                                                                id="consolidacionparcial3"
                                                                value={consolidacionParcial3}
                                                                variant="standard"
                                                                InputProps={{ startAdornment: <InputAdornment position="start">L.</InputAdornment>, readOnly: true }}
                                                            />
                                                        </FormControl>
                                                    </TableCell>
                                                </TableRow>)}
                                            {institucionNombre4 !== "" && montoLempiras4 !== "" && montoDolares4 !== "" && (
                                                <TableRow>
                                                    <StyledTableCell component="th" scope="row">
                                                        <FormControl sx={{ m: 1, width: 300 }}>
                                                            <TextField id="solicitanteBancoCuentaConsolidar4" value={institucionNombre4} label="Institución Financiera" variant="standard" InputProps={{ readOnly: true }} />
                                                        </FormControl>
                                                    </StyledTableCell>
                                                    <TableCell align="right">
                                                        <FormControl sx={{ m: 1, width: 100 }}>
                                                            <TextField
                                                                id="lempirasconsolidar4"
                                                                value={montoLempiras4}
                                                                variant="standard"
                                                                InputProps={{
                                                                    startAdornment: <InputAdornment position="start">L.</InputAdornment>,
                                                                    readOnly: true
                                                                }}
                                                            />
                                                        </FormControl>
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        <FormControl sx={{ m: 1, width: 100 }}>
                                                            <TextField
                                                                id="dolaresconsolidar4"
                                                                value={montoDolares4}
                                                                variant="standard"
                                                                InputProps={{
                                                                    startAdornment: <InputAdornment position="start">$.</InputAdornment>,
                                                                    readOnly: true
                                                                }}
                                                            />
                                                        </FormControl>
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        <FormControl sx={{ m: 1, width: 100 }}>
                                                            <TextField
                                                                id="total-lempiras-consolidar-4"
                                                                value={totalLempiras4}
                                                                variant="standard"
                                                                InputProps={{ readOnly: true, startAdornment: <InputAdornment position="start">L.</InputAdornment> }}
                                                            />
                                                        </FormControl>
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        <FormControl sx={{ m: 1, width: 100 }}>
                                                            <TextField
                                                                id="consolidaciontotal4"
                                                                value={consolidacionTotal4}
                                                                variant="standard"
                                                                InputProps={{ readOnly: true, startAdornment: <InputAdornment position="start">L.</InputAdornment> }}
                                                            />
                                                        </FormControl>
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        <FormControl sx={{ m: 1, width: 100 }}>
                                                            <TextField
                                                                id="consolidacionparcial4"
                                                                value={consolidacionParcial4}
                                                                variant="standard"
                                                                InputProps={{ startAdornment: <InputAdornment position="start">L.</InputAdornment>, readOnly: true }}
                                                            />
                                                        </FormControl>
                                                    </TableCell>
                                                </TableRow>)}

                                            {institucionNombre5 !== "" && montoLempiras5 !== "" && montoDolares5 !== "" && (
                                                <TableRow>
                                                    <StyledTableCell component="th" scope="row">
                                                        <FormControl sx={{ m: 1, width: 300 }}>
                                                            <TextField id="solicitanteBancoCuentaConsolidar5" value={institucionNombre5} label="Institución Financiera" variant="standard" InputProps={{ readOnly: true }} />
                                                        </FormControl>
                                                    </StyledTableCell>
                                                    <TableCell align="right">
                                                        <FormControl sx={{ m: 1, width: 100 }}>
                                                            <TextField
                                                                id="lempirasconsolidar5"
                                                                value={montoLempiras5}
                                                                variant="standard"
                                                                InputProps={{
                                                                    startAdornment: <InputAdornment position="start">L.</InputAdornment>,
                                                                    readOnly: true
                                                                }}
                                                            />
                                                        </FormControl>
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        <FormControl sx={{ m: 1, width: 100 }}>
                                                            <TextField
                                                                id="dolaresconsolidar5"
                                                                value={montoDolares5}
                                                                variant="standard"
                                                                InputProps={{
                                                                    startAdornment: <InputAdornment position="start">$.</InputAdornment>,
                                                                    readOnly: true
                                                                }}
                                                            />
                                                        </FormControl>
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        <FormControl sx={{ m: 1, width: 100 }}>
                                                            <TextField
                                                                id="total-lempiras-consolidar-5"
                                                                value={totalLempiras5}
                                                                variant="standard"
                                                                InputProps={{ readOnly: true, startAdornment: <InputAdornment position="start">L.</InputAdornment> }}
                                                            />
                                                        </FormControl>
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        <FormControl sx={{ m: 1, width: 100 }}>
                                                            <TextField
                                                                id="consolidaciontotal5"
                                                                value={consolidacionTotal5}
                                                                variant="standard"
                                                                InputProps={{ readOnly: true, startAdornment: <InputAdornment position="start">L.</InputAdornment> }}
                                                            />
                                                        </FormControl>
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        <FormControl sx={{ m: 1, width: 100 }}>
                                                            <TextField
                                                                id="consolidacionparcial5"
                                                                value={consolidacionParcial5}
                                                                variant="standard"
                                                                InputProps={{ startAdornment: <InputAdornment position="start">L.</InputAdornment>, readOnly: true }}
                                                            />
                                                        </FormControl>
                                                    </TableCell>
                                                </TableRow>)}

                                            <TableRow>
                                                <StyledTableCell component="th">
                                                    <Box sx={{ m: 1, width: 300 }} textAlign={"center"}>
                                                        <strong><label>TOTAL DEL PRÉSTAMO</label></strong>
                                                    </Box>
                                                </StyledTableCell>
                                                <TableCell align="right">
                                                    <FormControl sx={{ m: 1, width: 100 }}>
                                                        <TextField
                                                            id={`lempirasconsolidar`}
                                                            value={totalMontoLempiras1}
                                                            variant="standard"
                                                            InputProps={{
                                                                readOnly: true, startAdornment: <InputAdornment position="start">L.</InputAdornment>,
                                                            }}
                                                        />
                                                    </FormControl>
                                                </TableCell>
                                                <TableCell align="right">
                                                    <FormControl sx={{ m: 1, width: 100 }}>
                                                        <TextField
                                                            id={`dolaresconsolidar`}
                                                            value={totalMontoDolares1}
                                                            variant="standard"
                                                            InputProps={{
                                                                readOnly: true, startAdornment: <InputAdornment position="start">$.</InputAdornment>,
                                                            }}
                                                        />
                                                    </FormControl>
                                                </TableCell>
                                                <TableCell align="right">
                                                    <FormControl sx={{ m: 1, width: 100 }}>
                                                        <TextField
                                                            id={`total-lempiras-consolidar`}
                                                            value={totalTotalLempiras1}
                                                            variant="standard"
                                                            InputProps={{ readOnly: true, startAdornment: <InputAdornment position="start">L.</InputAdornment> }}
                                                        />
                                                    </FormControl>
                                                </TableCell>
                                                <TableCell align="right">
                                                    <FormControl sx={{ m: 1, width: 100 }}>
                                                        <TextField
                                                            id={`consolidaciontotal`}
                                                            value={totalConsolidacionTotal1}
                                                            variant="standard"
                                                            InputProps={{ readOnly: true, startAdornment: <InputAdornment position="start">L.</InputAdornment> }}
                                                        />
                                                    </FormControl>
                                                </TableCell>
                                                <TableCell align="right">
                                                    <FormControl sx={{ m: 1, width: 100 }}>
                                                        <TextField
                                                            id={`consolidacionparcial`}
                                                            value={totalConsolidacionParcial1}
                                                            variant="standard"
                                                            InputProps={{ readOnly: true, startAdornment: <InputAdornment position="start">L.</InputAdornment> }}
                                                        />
                                                    </FormControl>
                                                </TableCell>
                                            </TableRow>
                                            {/*<TableRow>
                                                <StyledTableCell component="th">
                                                    <Box sx={{ m: 1, width: 300 }} textAlign={"center"}>
                                                        <strong><label>MONTO A FAVOR DEL SOLICITANTE</label></strong>
                                                    </Box>
                                                </StyledTableCell>
                                                <TableCell align="right">
                                                    <FormControl sx={{ m: 1, width: 100 }}>
                                                        <TextField
                                                            id={`lempirasconsolidar`}
                                                            variant="standard"
                                                            value={totalMontoLempiras2}
                                                            InputProps={{
                                                                readOnly: true, startAdornment: <InputAdornment position="start">L.</InputAdornment>,
                                                            }}
                                                        />
                                                    </FormControl>
                                                </TableCell>
                                                <TableCell align="right">
                                                    <FormControl sx={{ m: 1, width: 100 }}>
                                                        <TextField
                                                            id={`dolaresconsolidar`}
                                                            variant="standard"
                                                            value={totalMontoDolares2}
                                                            InputProps={{
                                                                readOnly: true, startAdornment: <InputAdornment position="start">$.</InputAdornment>,
                                                            }}
                                                        />
                                                    </FormControl>
                                                </TableCell>
                                                <TableCell align="right">
                                                    <FormControl sx={{ m: 1, width: 100 }}>
                                                        <TextField
                                                            id={`total-lempiras-consolidar`}
                                                            value={totalTotalLempiras2}
                                                            variant="standard"
                                                            InputProps={{ readOnly: true, startAdornment: <InputAdornment position="start">L.</InputAdornment> }}
                                                        />
                                                    </FormControl>
                                                </TableCell>
                                                <TableCell align="right">
                                                    <FormControl sx={{ m: 1, width: 100 }}>
                                                        <TextField
                                                            id={`consolidaciontotal`}
                                                            variant="standard"
                                                            value={totalConsolidacionTotal2}
                                                            InputProps={{ readOnly: true, startAdornment: <InputAdornment position="start">L.</InputAdornment> }}
                                                        />
                                                    </FormControl>
                                                </TableCell>
                                                <TableCell align="right">
                                                    <FormControl sx={{ m: 1, width: 100 }}>
                                                        <TextField
                                                            id={`consolidacionparcial`}
                                                            variant="standard"
                                                            value={totalConsolidacionParcial2}
                                                            InputProps={{ readOnly: true, startAdornment: <InputAdornment position="start">L.</InputAdornment> }}
                                                        />
                                                    </FormControl>
                                                </TableCell>
                                            </TableRow>*/}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Box>
                        </Grid>
                    </Stack>
                </Box>
                <Divider style={{ marginTop: 10 }}></Divider>
                <Box marginTop={5}>
                    <h3>X. VOUCHERS DE PAGO EN FORMATO PDF</h3>
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                    >
                        <Box
                            style={{
                                padding: '50px',
                                width: '700px',
                                textAlign: 'center',
                                borderColor: 'gray',
                                borderRadius: 5,
                                borderWidth: 5,
                                borderStyle: 'dashed',
                            }}
                        >
                            <img src={pdficon} alt="Download PDF Icon" style={{ width: 75, height: 77, color: 'gray' }} />
                            <br />
                            <Button
                                variant="contained"
                                onClick={handleButtonVoucher}
                                style={{ marginTop: '10px', backgroundColor: '#ECECEC' }}
                            >
                                Ver Archivo PDF
                            </Button>
                            <p>Haz clic en el botón para visualizar el archivo PDF</p>
                            <Backdrop open={openPdfVoucher} onClick={handleCloseVoucher} style={{ zIndex: 1 }}>
                                <Dialog
                                    open={openPdfVoucher}
                                    onClose={handleCloseVoucher}
                                    maxWidth="md"
                                    fullWidth
                                >
                                    <DialogTitle textAlign={'center'}>Vouchers De Pago</DialogTitle>
                                    <DialogContent>
                                        <iframe
                                            src={pdfUrlVoucher}
                                            width="100%"
                                            height="450px"
                                            style={{ border: 'none' }}
                                        />
                                    </DialogContent>
                                </Dialog>
                            </Backdrop>
                        </Box>
                    </Box>
                </Box>

                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '10vh', // Establece la altura de la caja para ocupar toda la pantalla verticalmente
                    }}
                >
                </Box>
            </Container >
        </div>
    </>)
}

export default SolicitudCarga;
